export default {
  "content": "<path fill=\"#3F4450\" d=\"M5.918 11.418l-2.192-1.74-.726.874L6.084 13 13 4.712 12.107 4z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16"
  }
};